module.exports = __webpack_public_path__ + "img/PaidMedia-2.55881d43.png";